import React from 'react'
import { IMAGE_SIZE, DOC_SIZE, VIDEO_SIZE, DOMAIN } from "../../../umConfig";
import cx from "classnames";

const OtherSubmitButton = ({setAgreed,agreed,onClickFormSubmit}) => {
  return (
    <>
    <div className="form-check mb-3 mt-2 ">
      <input
        className="form-check-input"
        type="checkbox"
        id="agreement"
        checked={agreed}
        onChange={() => {
          setAgreed((b) => !b);
        }}
      />
      <label
        className="form-check-label"
        for="agreement"
      >
        I agree to all the terms and conditions.
      </label>
    </div>
    <button
      {...{
        className: cx(
          "btn",
          { "btn-secondary": !agreed },
          {
            "btn-primary":
              agreed &&
              window.location.hostname !== DOMAIN,
          },
          {
            kochar__color:
              window.location.hostname === DOMAIN &&
              agreed,
          }
        ),
        type: "submit",
        onClick: (e) => onClickFormSubmit(e),
        disabled: !agreed,
      }}
    >
      Submit
    </button>
  </>
  )
}

export default OtherSubmitButton